import { FormNode, FormState, ZExtensionProtocol } from "../types"


interface CommandActionMetadata {
  action<S = any, P = any>(states: FormState<S, P>): void;
}

const protocolPerform = async (
  currNodeGetter: () => FormNode<any, any>, 
  metadata: CommandActionMetadata, 
  safeChildrenCollection: Map<string, FormNode<any, any>>, 
  safeInvokeNode: (node: FormNode<any, any>) => Promise<any>
) => {
  // deep-first traversal
  for (const k of safeChildrenCollection.keys()) {
    const childNode = safeChildrenCollection.get(k)!
    safeInvokeNode(childNode) // for child nodes, fire and forget
  }
  
  try {
    const { action } = metadata ?? {}
    action?.(currNodeGetter().state) // it's ok that the node didn't register for the command
  } catch (error) {
    console.error(error)
  }
}
export type CommandActionProtocol<A extends string> = ZExtensionProtocol<`cmd-${A}`, CommandActionMetadata, unknown>


export const CommandActionProtocol = {
  create: <A extends string>(actionName: A) => {
    const metadataKey = `cmd-${actionName}` as const

    return {
      invoke: (invokeProtocol: (protocol: ZExtensionProtocol<string, any, any>) => Promise<void>) => {
        const protocol : CommandActionProtocol<A> = {
          metadataKey,
          perform: protocolPerform,
        }
        invokeProtocol(protocol)
      },

      metadataKey,
    }
  },
}
